/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Change_ShelfInputs */

const vi_sales_return_change_shelf = /** @type {(inputs: Sales_Return_Change_ShelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi kệ`)
};

/**

* @param {Sales_Return_Change_ShelfInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_change_shelf = /** @type {((inputs?: Sales_Return_Change_ShelfInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Change_ShelfInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_change_shelf(inputs)
});